import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import {
  createRootRoute,
  Outlet,
  ScrollRestoration,
} from "@tanstack/react-router"

import { Toaster } from "@/components/ui/toaster"
import { TooltipProvider } from "@/components/ui/tooltip"
import { EmbedProvider } from "@/components/context/embed-context"
import { ThemeProvider } from "@/components/providers/theme-provider"

import NotFound from "./not-found"

const queryClient = new QueryClient()

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
        <TooltipProvider>
          <EmbedProvider>
            <div
              vaul-drawer-wrapper=""
              className="overflow-x-hidden antialiased"
            >
              <ScrollRestoration />
              <Outlet />
            </div>
            <Toaster />
          </EmbedProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  ),
  notFoundComponent: () => <NotFound />,
})
